import { refreshAccessToken } from "@/apis/auth";
import { TokenPayload, User } from "@/types/user";
import jwt_decode from "jwt-decode";
import { create } from "zustand";

type UserStore = {
  user: User;
  logId: string;
  renewAccessToken: () => void;
  saveToken: (payload: TokenPayload) => void;
  updateUser: (updateUser: User) => void;
  clearUser: () => void;
  saveLogId: (logId: string) => void;
  clearLogId: () => void;
};

const useUserStore = create<UserStore>((set) => ({
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  async renewAccessToken() {
    const newToken = await refreshAccessToken();
    if (newToken) {
      this.saveToken(newToken);
    }
  },
  saveToken: (payload: TokenPayload) => {
    const user = jwt_decode<User>(payload.accessToken);

    localStorage.setItem("accessToken", payload.accessToken);
    localStorage.setItem("refreshToken", payload.refreshToken);
    localStorage.setItem("user", JSON.stringify(user));

    set({ user });
  },
  logId: "",
  saveLogId: (logId: string) => {
    localStorage.setItem("logId", logId);
    set({ logId });
  },
  updateUser: (updateUser: User) => {
    localStorage.setItem("user", JSON.stringify(updateUser));
    set({ user: updateUser });
  },
  clearUser: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    set({ user: {} as User });
  },
  clearLogId: () => {
    localStorage.removeItem("logId");
    set({ logId: "" });
  },
}));

export default useUserStore;
